import { PureComponent } from 'react';

import { get } from 'lodash-es';
import { connect } from 'react-redux';

import { Repository } from 'src/components/types';
import { SourceObject } from 'src/sections/repository/sections/source/types';
import { getCurrentRepository } from 'src/selectors/repository-selectors';
import { getTargetUserKey } from 'src/selectors/user-selectors';
import { BucketState } from 'src/types/state';

import { FileModuleMenu } from '../components/file-module-menu';

const mapStateToProps = (state: BucketState) => ({
  principalId: getTargetUserKey(state),
  repository: getCurrentRepository(state),
  hash: get(state, 'repository.source.section.hash'),
  sourceObject: state.repository.source.section.sourceObject,
});

type ConnectFileModuleMenuProps = {
  moduleKey?: string;
  moduleType: 'fileEditors' | 'fileViews';
  principalId: string | null | undefined;
  repository: Repository | null | undefined;
  hash?: string;
  defaultLabel: string;
  onSelect: (module?: string) => void;
  sourceObject: SourceObject | null | undefined;
};

class ConnectFileModuleMenu extends PureComponent<ConnectFileModuleMenuProps> {
  render() {
    const {
      moduleKey,
      moduleType,
      principalId,
      repository,
      hash,
      defaultLabel,
      onSelect,
      sourceObject,
    } = this.props;

    if (
      !principalId ||
      !repository ||
      !hash ||
      !sourceObject ||
      sourceObject.isLoading
    ) {
      return null;
    }

    const { path } = sourceObject;
    const [repositoryOwner, repositorySlug] = repository.full_name.split('/');

    return (
      <FileModuleMenu
        moduleKey={moduleKey}
        moduleType={moduleType}
        principalId={principalId}
        repositoryOwner={repositoryOwner}
        repositorySlug={repositorySlug}
        path={path}
        hash={hash}
        defaultLabel={defaultLabel}
        onSelect={onSelect}
      />
    );
  }
}

export default connect(mapStateToProps)(ConnectFileModuleMenu);
